<template>
    <div id="app" class="mobile-layout d-flex flex-column">
        <mobile-header v-if="!showDetail"></mobile-header>
        <detail-header v-else :content="content"></detail-header>
        <mobile-container>
            <slot></slot>
        </mobile-container>
    </div>
</template>

<script>
import MobileContainer from './mobile/mobile-container';
import MobileHeader from './mobile/mobile-header';
import DetailHeader from './mobile/detail-header';

export default {
    name: 'MobileLayout',

    components: { MobileContainer, MobileHeader, DetailHeader },

    props: {
        footer: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        showDetail() {
            return this.$route.meta.showDetail || false;
        },
        content() {
            return this.$route.meta.title;
        }
    }
};
</script>

<style lang="scss" scoped>
.van-toast {
    display: flex;
    justify-content: space-between;
    width: 160px;
    height: 48px;
    line-height: 48px;
}
</style>
